import { SxProps, TextField as MuiTextField, Theme } from '@mui/material'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type TextFieldProps = {
  type?: React.InputHTMLAttributes<unknown>['type']
  label?: string
  name: string
  placeholder?: string
  maxLength?: number
  minRows?: number
  multiline?: boolean
  sx?: SxProps<Theme>
  control: Control<any>
  disabled?: boolean
  required?: boolean
  readonly?: boolean
}

const FormInput: React.FC<TextFieldProps> = ({
  type,
  label,
  name,
  placeholder,
  maxLength,
  multiline,
  minRows,
  sx,
  control,
  disabled,
  readonly,
  required = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MuiTextField
          type={type}
          fullWidth
          id={`${name}Id`}
          label={label}
          name={name}
          value={value || ''}
          size='small'
          placeholder={placeholder}
          onChange={onChange}
          InputProps={{
            inputProps: {
              maxLength: maxLength || 255,
            },
            readOnly: readonly,
          }}
          minRows={minRows}
          multiline={multiline}
          sx={sx}
          error={!!error}
          helperText={error && error.message && error.message}
          disabled={disabled}
          required={required}
        />
      )}
    />
  )
}

export default FormInput
